import { useEffect, useState } from "react";

import {
  useActiverUtilisateur,
  useDesactiverUtilisateur,
  useGetAllUtilisateursAdb,
  useGetAllUtilisateursBesse,
  useGetFonctionsPostes,
  useGetUtilisateurByUsername,
} from "../../../hooks/Utilisateurs";
import { useGetAdbDetail } from "../../../hooks/AdministrateurDeBien";
import { useSelector } from "react-redux";
import Types from "Types";
import { Selectors as AdbSelectors } from "../../../redux/AdministrateurDeBien";
import {
  Selectors as UtilisateursSelectors,
  ActionCreators as UtilisateursActionCreators,
} from "../../../redux/Utilisateurs";
import { getIdsAdb } from "../helpers";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";

interface CriteresRecherche {
  numAdherent?: number;
  nom?: string;
  prenom?: string;
  statut?: boolean;
  fonction?: string;
  profilBesse?: boolean;
}

interface Pagination {
  orderBy: string;
  sortColumn: string;
  sortOrder: "asc" | "desc";
  page: number;
  nbrElementParPage: number;
}
const DEFAULT_NBR_ELEMENT_PAR_PAGE = 20;
const DEFAULT_SORT_COLUMN = "nom";
const DEFAULT_SORT_ORDER = "asc";

export const useRechercheUtilisateur = () => {
  // confirmationCreationUtilisateur: (confirmation: boolean) =>
  //     dispatch(
  //       UtilisateursActionsCreator.confirmationCreationUtilisateur(confirmation),

  //  ------------------ API CALLS -----------------------
  const { data: fonctionsPostes } = useGetFonctionsPostes();
  const {
    mutate: mutateAllUtilisateursBesse,
    isLoading: searchingUtilisateurBesse,
  } = useGetAllUtilisateursBesse();
  const getAllUtilisateursBesse = (params: {
    nom?: string | undefined;
    prenom?: string | undefined;
    statut?: string | undefined;
    page?: number | undefined;
    taille?: number | undefined;
    tri?: string | undefined;
  }) => {
    mutateAllUtilisateursBesse(params);
  };

  const {
    mutate: mutateAllUtilisateursAdb,
    isLoading: searchingUtilisateurAdb,
  } = useGetAllUtilisateursAdb();
  const getAllUtilisateursAdb = (params: {
    numAdherent: number;
    nom?: string | undefined;
    prenom?: string | undefined;
    statut?: string | undefined;
    fonction?: string | undefined;
    page?: number | undefined;
    taille?: number | undefined;
    tri?: string | undefined;
  }) => {
    mutateAllUtilisateursAdb(params);
  };

  const {
    mutate: mutateActiverUtilisateur,
    isSuccess: confirmationActivationUtilisateur,
    reset: resetActivationUtilisateur,
  } = useActiverUtilisateur();
  const activerUtilisateur = (params: string) => {
    mutateActiverUtilisateur(params);
  };

  const {
    mutate: mutateDesactiverUtilisateur,
    isSuccess: confirmationDesactivationUtilisateur,
    reset: resetDesactivationUtilisateur,
    isLoading: desactiverFetching,
    error: desactiverError,
  } = useDesactiverUtilisateur();
  const desactiverUtilisateur = (params: string) => {
    mutateDesactiverUtilisateur(params);
  };

  // ------------------------------ SELECTORS --------------------------

  const utilisateurConnecte = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getUtilisateurConnecte(state)
  );
  const showConfirmationCreation = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getConfirmationCreationUtilisateur(state)
  );
  const searchResults = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getSearchResults(state)
  );
  const searchCount = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getSearchCount(state)
  );
  const searching = searchingUtilisateurBesse || searchingUtilisateurAdb;
  const searchError = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.getSearchError(state)
  );
  const idAdb = useSelector((state: Types.RootState) =>
    AdbSelectors.getAdbId(state)
  );

  const isChargeClienteleBesse = useSelector((state: Types.RootState) =>
    UtilisateursSelectors.isChargeClienteleBesse(state)
  );

  const dispatch = useDispatch();

  // -----------------------ACTIONS TABLEAUX ------------------------
  const [criteres, setCriteres] = useState<CriteresRecherche>({});
  const [pagination, setPagination] = useState<Pagination>({
    page: 0,
    nbrElementParPage: DEFAULT_NBR_ELEMENT_PAR_PAGE,
    orderBy: DEFAULT_SORT_COLUMN,
    sortColumn: "nom",
    sortOrder: "asc",
  });

  useEffect(() => {
    lancerRecherche(true);
    setTimeout(handleClose, 5000);
  }, []);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/mes-utilisateurs/ajouter");
  };
  const handleClickBesse = () => {
    navigate("/mes-utilisateurs/ajouterBesse");
  };

  const handleClose = () => {
    dispatch(UtilisateursActionCreators.confirmationCreationUtilisateur(false));
    resetActivationUtilisateur();
    resetDesactivationUtilisateur();
  };

  const handleChangeCritere = (id: string, value: string | boolean) => {
    setCriteres({
      ...criteres,
      [id]: value,
    });
  };

  const [searchParams, setSearchParams] = useState<CriteresRecherche>();
  const handleRechercher = () => {
    // Si on lance la recherche par le bouton Rechercher (et donc changement de critères)
    // on réinitialise le numéro de page
    lancerRecherche(true);
    setSearchParams(criteres);
  };

  const lancerRecherche = (resetPage: boolean) => {
    // On construit la requête de recherche en cumulant les critères de recherche
    // et les infos de pagination

    const page = resetPage ? 0 : pagination.page || 0;
    const params = {
      ...(criteres.nom ? { nom: criteres.nom } : {}),
      ...(criteres.prenom ? { prenom: criteres.prenom } : {}),
      ...(criteres.fonction ? { fonction: criteres.fonction } : {}),
      ...(criteres.statut
        ? { statut: criteres.statut ? "ACTIF" : "BLOQUE" }
        : {}),
      ...(criteres.profilBesse
        ? { profilBesse: criteres.profilBesse ? "BESSE" : "ADB" }
        : {}),
      ...{ page },
      ...(pagination.nbrElementParPage
        ? { taille: pagination.nbrElementParPage }
        : { taille: DEFAULT_NBR_ELEMENT_PAR_PAGE }),
      ...(pagination.sortColumn
        ? {
            tri: `${pagination.sortColumn}:${
              pagination.sortOrder || DEFAULT_SORT_ORDER
            }`,
          }
        : { tri: `${DEFAULT_SORT_COLUMN}:${DEFAULT_SORT_ORDER}` }),
    };
    if (resetPage) {
      setPagination({
        ...pagination,
        page: 0,
      });
    }
    if (utilisateurConnecte && utilisateurConnecte.role === "BESSE") {
      if (!idAdb || criteres.profilBesse) {
        getAllUtilisateursBesse(params);
      } else {
        getAllUtilisateursAdb({
          ...{ numAdherent: idAdb },
          ...params,
        });
      }
    } else {
      // TODO action back qui attendra un tableau d'id si plusieurs adb pour l'utilisateur connecte
      // en attendant on prend le premier
      const idsAdbs = utilisateurConnecte && getIdsAdb(utilisateurConnecte);
      idsAdbs &&
        idsAdbs[0] &&
        getAllUtilisateursAdb({
          ...{ numAdherent: idsAdbs[0] },
          ...params,
        });
    }
  };

  const handleReessayer = () => {
    lancerRecherche(true);
  };

  const handleChangeTri = (sortColumn: string, sortOrder: "asc" | "desc") => {
    setPagination({
      ...pagination,
      sortColumn,
      sortOrder,
    });
    lancerRecherche(false);
  };

  const handleChangePage = (page: number) => {
    setPagination({
      ...pagination,
      page,
    });
    lancerRecherche(false);
  };

  const handleChangeNbrElementParPage = (nbrElementParPage: number) => {
    setPagination({
      ...pagination,
      nbrElementParPage,
    });

    lancerRecherche(false);
  };

  const handleChangeStatut = (id: string, statut: boolean) => {
    if (!statut) {
      desactiverUtilisateur(id);
    } else {
      activerUtilisateur(id);
    }
  };

  const {
    mutate: mutateUtilisateurByUsername,
    isSuccess: isSuccessGetUtilisateur,
    error: errorGetUtilisateur,
    reset: resetGetUtilisateur,
  } = useGetUtilisateurByUsername();
  const getUtilisateurByUsername = (params: string) => {
    mutateUtilisateurByUsername(params);
  };
  const handleConsulter = (username: string) => {
    getUtilisateurByUsername(username);
  };

  useEffect(() => {
    resetGetUtilisateur();
    if (isSuccessGetUtilisateur) {
      if (
        (idAdb && !criteres.profilBesse) ||
        (utilisateurConnecte && utilisateurConnecte.role === "ADB")
      ) {
        navigate("/mes-utilisateurs/modifier");
      } else {
        navigate("/mes-utilisateurs/modifierBesse");
      }
    }
  }, [isSuccessGetUtilisateur]);
  return {
    handleClick,
    handleClickBesse,
    handleChangeCritere,
    handleRechercher,
    lancerRecherche,
    handleReessayer,
    handleChangeTri,
    handleChangePage,
    handleChangeNbrElementParPage,
    handleChangeStatut,
    handleConsulter,
    fonctionsPostes,
    confirmationActivationUtilisateur,
    confirmationDesactivationUtilisateur,
    desactiverFetching,
    desactiverError,
    searchResults,
    searchCount,
    searching,
    searchError,
    isChargeClienteleBesse,
    utilisateurConnecte,
    idAdb,
    criteres,
    searchParams,
    handleClose,
    pagination,
    showConfirmationCreation,
    errorGetUtilisateur,
    resetGetUtilisateur,
  };
};
